module.exports = __webpack_public_path__ + "static/media/Step1.dc84c7eb.svg";